import React, { useState, useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { useHistory } from "react-router-dom";
import { Typography, Button, Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((file) => ({
	form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: "1rem",
	},
	submit: {
		margin: file.spacing(2, 0, 1),
	},
}));

const baseStyle = {
	marginTop: "1rem",
	flex: 1,
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	minHeight: "20vh",
	borderWidth: 4,
	borderRadius: 10,
	borderColor: "#ddd",
	borderStyle: "dashed",
	backgroundColor: "#eee",
	color: "#888",
	fontWeight: "bold",
	outline: "none",
	transition: "border .24s ease-in-out",
	cursor: "pointer",
};

const activeStyle = {
	borderColor: "#2196f3",
};

const acceptStyle = {
	borderColor: "#00e676",
};

const rejectStyle = {
	borderColor: "#ff1744",
};

export default function FilesAdd(props) {
	const classes = useStyles();
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [fileInfo, setFileInfo] = useState("");
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();

	const onDrop = useCallback((acceptedFiles) => {
		setSelectedFiles(acceptedFiles);
		const droppedFiles = acceptedFiles.map((file) => (
			<li key={file.path}>
				<Typography>
					<b>{file.path}</b> - {(file.size / 1024).toFixed(2)}KB
				</Typography>
			</li>
		));

		setFileInfo(droppedFiles);
	}, []);

	const {
		getRootProps,
		getInputProps,
		isDragActive,
		isDragAccept,
		isDragReject,
	} = useDropzone({ onDrop });

	const style = useMemo(
		() => ({
			...baseStyle,
			...(isDragActive ? activeStyle : {}),
			...(isDragAccept ? acceptStyle : {}),
			...(isDragReject ? rejectStyle : {}),
		}),
		[isDragActive, isDragReject, isDragAccept]
	);

	const onClickRemoveAll = (e) => {
		setFileInfo("");
		setSelectedFiles([]);
	};

	const onSubmit = (e) => {
		e.preventDefault();
		const formData = new FormData();

		for (const file in selectedFiles) {
			formData.append(file, selectedFiles[file]);
		}

		console.log(formData);

		fetch(`${process.env.REACT_APP_API_URL}/files`, {
			method: "POST",
			credentials: "include",
			body: formData,
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					enqueueSnackbar("File added successfully!", { variant: "success" });
					history.push(`/${process.env.REACT_APP_ADMIN_URL}/files`);
				} else {
					console.log(data);
					const errorArray = data.error.split(",");
					errorArray.forEach((error) => {
						enqueueSnackbar(`${error}`, { variant: "error" });
					});
				}
			});
	};

	return (
		<>
			<Typography component="h1" variant="h4">
				Add a File
			</Typography>
			<div {...getRootProps({ style })}>
				<input {...getInputProps()} />
				{isDragActive ? (
					<p>Drop the files here...</p>
				) : (
					<>
						<p>Drag 'n' drop some files here, or click to select files</p>
						<p>
							Allowed file types: docx, doc, pdf, mp3, mp4, jpg, png, svg, txt,
							csv, xls, xlsx
						</p>
					</>
				)}
			</div>
			{fileInfo && (
				<Card style={{ marginTop: "1rem" }}>
					<CardContent>
						<Typography variant="h5" color="primary">
							Selected Files
						</Typography>
						<ul style={{ listStyleType: "none", paddingLeft: 0 }}>
							{fileInfo}
						</ul>
						<Button
							color="secondary"
							variant="contained"
							onClick={onClickRemoveAll}
						>
							Remove All
						</Button>
					</CardContent>
				</Card>
			)}
			<Button
				type="submit"
				fullWidth
				variant="contained"
				color="primary"
				className={classes.submit}
				onClick={onSubmit}
			>
				Upload
			</Button>
		</>
	);
}
